/**
 * Mapeia o idioma da app para locale BCP-47 usado em Intl.DisplayNames (nomes de países).
 */
export function languageToBcp47(language) {
  const map = {
    'pt-BR': 'pt-BR',
    'pt-PT': 'pt-PT',
    en: 'en-US',
    es: 'es',
    fr: 'fr',
    it: 'it',
    hi: 'hi',
    de: 'de',
    nl: 'nl',
    ru: 'ru',
    ar: 'ar',
    'zh-CN': 'zh-CN',
    'zh-TW': 'zh-TW'
  };
  return map[language] || 'en-US';
}
